import { render, staticRenderFns } from "./SalaryExcelMonthHQ.vue?vue&type=template&id=492315e2&scoped=true"
import script from "./SalaryExcelMonthHQ.vue?vue&type=script&lang=js"
export * from "./SalaryExcelMonthHQ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492315e2",
  null
  
)

export default component.exports